(function installAskAvantreeHandoff(global) {
  "use strict";

  function prepareZendesk(zendesk) {
    if (typeof zendesk !== "function") return;
    zendesk("messenger", "hide");
    zendesk("messenger:set", "customization", {
      conversationList: { hideNewConversationButton: true },
    });
  }

  function create(options) {
    var onDiagnostic = options && typeof options.onDiagnostic === "function" ? options.onDiagnostic : function () {};
    var onConversationId = options && typeof options.onConversationId === "function" ? options.onConversationId : function () {};

    function reportDiagnostic(phase, error, httpStatus) {
      function safeCode(value) {
        if (typeof value !== "string" || !/^[A-Za-z][A-Za-z0-9 _.-]{0,79}$/.test(value) || /\d{6,}/.test(value)) return null;
        return value;
      }
      try {
        onDiagnostic({
          phase: phase,
          type: safeCode(error && error.type),
          reason: safeCode(error && error.reason),
          code: safeCode(error && error.code),
          httpStatus: Number.isInteger(httpStatus) ? httpStatus : null,
          multiConvoEnabled: typeof multiConvoEnabled === "boolean" ? multiConvoEnabled : null,
          canUserCreateMoreConversations: typeof canUserCreateMoreConversations === "boolean" ? canUserCreateMoreConversations : null,
        });
      } catch {}
    }

    if (!options || typeof options.sessionId !== "string" || !options.sessionId.trim()) {
      reportDiagnostic("adapter_session", null);
      throw new Error("sessionId is required");
    }
    var zendesk = options.zE || global.zE;
    var fetcher = options.fetch || global.fetch.bind(global);
    var endpoint = options.endpoint;
    var onState = typeof options.onState === "function" ? options.onState : function () {};
    var traceId = options.canonicalTraceId || null;
    var locale = options.locale || "en-US";
    var timeoutId = null;
    var setupTimeoutId = null;
    var conversationId = null;
    var multiConvoEnabled = null;
    var canUserCreateMoreConversations = null;
    var plan = null;
    var queueTimeoutMs = null;
    var fallbackStarted = false;
    var agentConnected = false;
    var unsubscribers = [];

    function post(action, extra) {
      return fetcher(endpoint, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(Object.assign({
          action: action,
          session_id: options.sessionId,
          canonical_trace_id: traceId,
          locale: locale,
        }, extra || {})),
      }).then(function (response) {
        return response.json().then(function (body) {
          if (!response.ok || body.ok === false) {
            reportDiagnostic("followup_" + action, { reason: body.error }, response.status);
            throw new Error("handoff_request_failed");
          }
          if (action === "messaging_event" && extra && extra.event === "transfer_requested") reportDiagnostic("followup_transfer_requested_ok", null, response.status);
          return body;
        });
      }).catch(function (error) {
        if (!error || error.message !== "handoff_request_failed") reportDiagnostic("followup_" + action, error);
        throw error;
      });
    }

    function emit(result) {
      onState({
        channel: result.channel,
        status: result.messagingStatus || (result.emailRequired ? "email_required" : result.messaging ? "starting" : result.handoff && result.handoff.completed ? "sent" : "failed"),
        message: result.customerMessage || "",
        emailRequired: result.emailRequired === true,
        emailReused: result.emailReused === true,
      });
      return result;
    }

    function eventConversationId(event) {
      return event && (
        event.conversationId
        || event.data && (event.data.conversationId || event.data.conversation_id)
        || event.payload && event.payload.conversation && event.payload.conversation.id
      );
    }

    function matches(event) {
      var id = eventConversationId(event);
      return Boolean(id && conversationId && id === conversationId);
    }

    function bindZendeskEvents() {
      if (unsubscribers.length) return;
      var queuedUnsubscribe = zendesk("messenger:on", "conversationWithAgentRequested", function (event) {
        if (!matches(event) || !conversationId) {
          reportDiagnostic("sdk_agent_request_ignored", { reason: eventConversationId(event) ? "conversation_mismatch" : "conversation_id_missing" });
          return;
        }
        if (fallbackStarted || agentConnected) return;
        reportDiagnostic("sdk_agent_request_matched", null);
        post("messaging_event", { event: "queued", provider_conversation_id: conversationId })
          .then(function (result) {
            if (fallbackStarted || agentConnected) return result;
            startQueueTimeout(result.queueTimeoutMs);
            return emit(result);
          })
          .catch(failMessaging);
      });
      var connectedUnsubscribe = zendesk("messenger:on", "conversationAgentAssigned", function (event) {
        if (!matches(event) || fallbackStarted) return;
        agentConnected = true;
        clearQueueTimeout();
        onState({ channel: "messaging", status: "connected", message: "An agent has joined the conversation.", emailRequired: false, emailReused: false });
      });
      if (typeof queuedUnsubscribe === "function") unsubscribers.push(queuedUnsubscribe);
      if (typeof connectedUnsubscribe === "function") unsubscribers.push(connectedUnsubscribe);
    }

    function storageKey(suffix) {
      return "ask-avantree-handoff:" + plan.idempotencyKey + ":" + suffix;
    }

    function storedConversationId() {
      try { return global.localStorage.getItem(storageKey("conversation")); } catch { return null; }
    }

    function storeConversation(id) {
      try {
        global.localStorage.setItem(storageKey("conversation"), id);
        global.localStorage.setItem(storageKey("message-sent"), "true");
      } catch {}
    }

    function messageWasSent() {
      try { return global.localStorage.getItem(storageKey("message-sent")) === "true"; } catch { return false; }
    }

    function showConversation(id, result) {
      clearSetupTimeout();
      if (result.messagingStatus === "queued" && timeoutId === null && !agentConnected) startQueueTimeout(result.queueTimeoutMs);
      var askRoot = global.document && global.document.querySelector("[data-ask-avantree-root]");
      if (askRoot && askRoot.dataset.open === "true" && global.AskAvantree && typeof global.AskAvantree.close === "function") {
        try {
          global.AskAvantree.close();
          reportDiagnostic("ask_drawer_closed_for_messaging", null);
        } catch (error) {
          reportDiagnostic("ask_drawer_close_failed", error);
        }
      }
      zendesk("messenger", "show");
      reportDiagnostic("sdk_widget_show", null);
      if (multiConvoEnabled) zendesk("messenger:ui", "navigation", { screen: "Conversation", options: { conversationId: id } });
      zendesk("messenger", "open");
      reportDiagnostic("sdk_widget_open", null);
      return result;
    }

    function markTransferRequested(id) {
      if (fallbackStarted) return Promise.resolve();
      conversationId = id;
      storeConversation(id);
      try { onConversationId(id); } catch {}
      reportDiagnostic("sdk_conversation_created", null);
      return post("messaging_event", { event: "transfer_requested", provider_conversation_id: id }).then(function (result) {
        if (fallbackStarted) return result;
        showConversation(id, result);
        return emit(result);
      });
    }

    function requireSupportedConversation(existingConversationId) {
      return new Promise(function (resolve, reject) {
        reportDiagnostic("sdk_config_requested", null);
        zendesk("messenger:get", "config", function (config) {
          reportDiagnostic("sdk_config_received", null);
          if (!config) {
            reportDiagnostic("sdk_config_unavailable", null);
            reject(new Error("zendesk_config_unavailable"));
            return;
          }
          multiConvoEnabled = config.multiConvoEnabled === true;
          canUserCreateMoreConversations = config.canUserCreateMoreConversations === true;
          if (multiConvoEnabled && !existingConversationId && !canUserCreateMoreConversations) {
            reportDiagnostic("sdk_new_conversation_unavailable", null);
            reject(new Error("zendesk_new_conversation_unavailable"));
            return;
          }
          resolve();
        });
      });
    }

    function sendToExisting(id) {
      if (!plan.initialMessageRequired || messageWasSent()) return markTransferRequested(id);
      return new Promise(function (resolve, reject) {
        zendesk("messenger", "sendMessage", {
          content: { type: "text", text: plan.initialMessage },
          metadata: plan.metadata,
        }, id, function (error) {
          if (error) {
            reportDiagnostic("sdk_send_message", error);
            reject(error);
          }
          else markTransferRequested(id).then(resolve, reject);
        });
      });
    }

    function createConversation() {
      return new Promise(function (resolve, reject) {
        reportDiagnostic("sdk_new_conversation_requested", null);
        zendesk("messenger", "newConversation", {
          displayName: plan.displayName,
          metadata: plan.metadata,
          message: {
            content: { type: "text", text: plan.initialMessage },
            metadata: plan.metadata,
          },
        }, function (creationError, result) {
          if (fallbackStarted) return;
          reportDiagnostic("sdk_new_conversation_callback", creationError);
          if (creationError || !result || !result.id) {
            reportDiagnostic("sdk_new_conversation", creationError);
            reject(creationError || new Error("zendesk_conversation_not_created"));
          }
          else markTransferRequested(result.id).then(resolve, reject);
        });
      });
    }

    function startQueueTimeout(milliseconds) {
      clearQueueTimeout();
      reportDiagnostic("queue_timeout_started", null);
      timeoutId = global.setTimeout(function () {
        if (fallbackStarted || agentConnected) return;
        fallbackStarted = true;
        reportDiagnostic("queue_timeout_fired", null);
        post("messaging_timeout").then(emit).catch(function () {
          onState({ channel: "email", status: "failed", message: "We couldn't connect you or send your request. Please try again later or email support@ivintree.com.", emailRequired: false, emailReused: false });
        });
      }, milliseconds);
    }

    function startSetupTimeout(milliseconds) {
      clearSetupTimeout();
      reportDiagnostic("sdk_setup_timeout_started", null);
      setupTimeoutId = global.setTimeout(function () {
        reportDiagnostic("sdk_setup_timeout_fired", null);
        failMessaging();
      }, milliseconds);
    }

    function clearSetupTimeout() {
      if (setupTimeoutId !== null) global.clearTimeout(setupTimeoutId);
      setupTimeoutId = null;
    }

    function clearQueueTimeout() {
      if (timeoutId !== null) global.clearTimeout(timeoutId);
      timeoutId = null;
    }

    function failMessaging() {
      if (fallbackStarted || agentConnected) return;
      fallbackStarted = true;
      clearSetupTimeout();
      clearQueueTimeout();
      if (!conversationId) {
        post("messaging_failure").then(emit).catch(function () {
          onState({ channel: "email", status: "failed", message: "We couldn't connect you or send your request. Please try again later or email support@ivintree.com.", emailRequired: false, emailReused: false });
        });
        return;
      }
      post("messaging_event", { event: "provider_failed", provider_conversation_id: conversationId })
        .then(emit)
        .catch(function () {
          onState({ channel: "email", status: "failed", message: "We couldn't connect you or send your request. Please try again later or email support@ivintree.com.", emailRequired: false, emailReused: false });
        });
    }

    function start() {
      return post("start").then(function (result) {
        emit(result);
        if (result.channel !== "messaging" || !result.messaging) return result;
        plan = result.messaging;
        queueTimeoutMs = result.queueTimeoutMs;
        conversationId = plan.providerConversationId || storedConversationId();
        if (plan.routingTag !== "ask_avantree_pr_1897" && plan.routingTag !== "ask_avantree_live") {
          reportDiagnostic("routing_tag_unavailable", null);
          failMessaging();
          return result;
        }
        if (typeof zendesk !== "function") {
          reportDiagnostic("sdk_unavailable", null);
          failMessaging();
          return result;
        }
        if (!conversationId && plan.correlationTag) {
          try { zendesk("messenger:set", "conversationTags", [plan.routingTag, plan.correlationTag]); }
          catch (error) { reportDiagnostic("sdk_conversation_tag", error); }
        }
        try {
          prepareZendesk(zendesk);
          bindZendeskEvents();
          startSetupTimeout(queueTimeoutMs);
        } catch (error) {
          reportDiagnostic("sdk_event_binding", error);
          failMessaging();
          return result;
        }
        return requireSupportedConversation(conversationId)
          .then(function () {
            if (fallbackStarted) return result;
            if (conversationId && (result.messagingStatus === "queued" || result.messagingStatus === "connecting")) {
              if (!multiConvoEnabled && storedConversationId() !== conversationId) throw new Error("zendesk_handoff_conversation_missing");
              return showConversation(conversationId, result);
            }
            return conversationId ? sendToExisting(conversationId) : createConversation();
          })
          .catch(function (error) {
            failMessaging(error);
            return result;
          });
      });
    }

    function submitEmail(email) {
      return post("submit_email", { email: email, consent: true }).then(emit);
    }

    function destroy() {
      clearSetupTimeout();
      clearQueueTimeout();
      unsubscribers.splice(0).forEach(function (unsubscribe) { unsubscribe(); });
    }

    return { start: start, submitEmail: submitEmail, destroy: destroy };
  }

  try { prepareZendesk(global.zE); } catch {}
  global.AskAvantreeHandoff = { create: create };
})(typeof window === "undefined" ? globalThis : window);
